import {Component} from 'react';
import h from 'react-hyperscript';
import './Breadcrumbs.scss';
import {h4} from 'Components/Typography/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import {REPORT} from 'Src/utils/gtm/const';
import {pushEvent as pushGTMEvent} from 'Src/utils/gtm';
import Dropdown from '../Dropdown/Dropdown';
import ShareLinkModal from '../ShareLinkModal/ShareLinkModal';
import TooltipGroup from 'Components/TooltipGroup/TooltipGroup';
import MMembers from '../../ReportCardOverview/ManageMembers/ManageMembers';
import {ENDPOINTS} from 'Src/utils/utils';

class Breadcrumbs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shareModalOpen: false,
      shareLinkModalOpen: false,
    };
  }

  setShareModalOpen(value) {
    this.setState({...this.state, shareModalOpen: value});
  };

  setShareLinkModalOpen(value) {
    this.setState({...this.state, shareLinkModalOpen: value});
  };

  render() {
    const downloadReport = (e) => {
      e.preventDefault();
      pushGTMEvent(REPORT.TAG, {
        event: REPORT.EVENT,
        action: {report_action: REPORT.ACTION.DOWNLOAD},
      });
      const {reportId} = this.props;
      if (reportId) {
        fetch(ENDPOINTS.REPORT_DOWNLOAD, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': this.props.idToken,
            'X-CSRF-Token': this.props.csrf,
          },
          body: JSON.stringify({
            report_card_id: reportId,
          }),
        });
      }
      window.print();
    };
    return h(
        'div',
        {
          id: 'breadcrumbs',
          className: 'flex--align-start flex--column flex--wrap',
        },
        [
          h(
              'div',
              {
                className: 'flex flex--wrap-md',
              },
              [
                h(
                    h4,
                    {
                      className: 'text--grey flex',
                    },
                    [
                      `${this.props.districtName}'s Report`,
                      h(
                          'span',
                          {
                            className: `material-icons text--grey
                              padding-left--micro`,
                          },
                          'keyboard_arrow_right'
                      ),
                    ]
                ),
                h(
                    Dropdown,
                    {
                      reportCardName: this.props.reportCardName,
                      downloadReport: downloadReport,
                      googleUser: this.props.googleUser,
                      csrf: this.props.csrf,
                      idToken: this.props.idToken,
                      districtId: this.props.districtId,
                      openShareModal: () => this.setShareModalOpen(true),
                      openShareLinkModal:
                          () => this.setShareLinkModalOpen(true),
                    },
                ),

                h(ShareLinkModal, {
                  open: this.state.shareLinkModalOpen,
                  handleClose: () => this.setShareLinkModalOpen(false),
                }),


                h('div', {id: 'breadcrumbs__icons-container'}, [
                  h('div', {className: 'breadcrumbs__icon'}, [
                    h(
                        MMembers, {
                          members: this.props.sharedUsers,
                          userStatus: this.props.userStatus,
                          setMembers: this.props.setSharedUsers,
                          googleUser: this.props.googleUser,
                          csrf: this.props.csrf,
                          idToken: this.props.idToken,
                          districtId: this.props.districtId,
                          style: {
                            display: 'flex',
                          },
                          externalOpen: this.state.shareModalOpen,
                          handleClose: () => this.setShareModalOpen(false),
                        }
                    ),
                  ]),
                  h('div', {className: 'breadcrumbs__icon'}, [
                    h(
                        Tooltip,
                        {
                          title: 'Get shareable link',
                        },
                        [
                          h(
                              'button',
                              {
                                className:
                                  'button button--flat',
                                onClick: () =>
                                  this.setShareLinkModalOpen(true),
                                tabIndex: 0,
                                role: 'button',
                              },
                              [
                                h(
                                    'span',
                                    {
                                      className: 'material-icons',
                                    },
                                    'link'
                                ),
                              ]
                          ),
                        ]),
                  ]),
                  h('div', {className: 'breadcrumbs__icon'}, [
                    h(
                        Tooltip,
                        {
                          title: 'Download PDF',
                        },
                        [
                          h(
                              'button',
                              {
                                className:
                                  `button button--flat`,
                                tabIndex: 0,
                                role: 'button',
                                onClick: downloadReport,
                              },
                              [
                                h(
                                    'span',
                                    {
                                      className: 'material-icons',
                                    },
                                    'get_app'
                                ),
                              ]
                          ),
                        ]),

                  ]),
                ]),

              ]
          ),
          h('div', {
            className: 'denominator-container',
          },
          h(TooltipGroup, {
            title: 'As self-reported in your settings',
          }, [
            h('p', {
              className: 'denomatinator-container__text',
            },
            [
              h('span', `Faculty: ${this.props.userStatus.num_teachers}`),
              h('span', {
                style: {marginLeft: 10 + 'px'},
              }, `Students: ${this.props.userStatus.num_students}`),
            ]
            ),
          ]),
          ),
        ]
    );
  }
}

export default Breadcrumbs;
